import React, { useState, useContext } from "react";
import { Card, CardTitle, CardBody, CardFooter, Button } from "reactstrap";
import { setToken } from "../../api/index";
import { AuthContext } from "../../context/authProvider";
import { useHistory } from "react-router-dom";
import Loader from "../../components/loader/loader";
import loginBg from "../../assets/images/background/LoginBg.jpg";
import PhoneInput from "react-phone-number-input";
import { ToastContext } from "../../context/toastProvider";
import authService from "../../api/services/authService";

export default function Login() {
  const history = useHistory();
  const [username, setUsername] = useState(null);
  const [forgotPassword, setForgotPassword] = useState(false);
  const [password, setPassword] = useState(null);
  const [error, setError] = useState({ error: false, message: "" });
  const { setUser } = useContext(AuthContext);
  const [clientToken, setClientToken] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [mobileNumber, setMobileNumber] = useState();
  const { initToast } = useContext(ToastContext);
  const [otp, setOtp] = useState({
    otpActive: false,
    otp: "",
    ott: "",
    message: "",
  });

  const passwordReset = async () => {
    setIsLoading(true);
    const resetResp = await authService.resetPassword({
      mobileNumber: mobileNumber,
    });
    if (resetResp.status) {
      initToast("success", resetResp.message);
      setIsLoading(false);
      setForgotPassword(false);
    } else {
      initToast("error", resetResp.message);
      setIsLoading(false);
    }
  };

  async function login() {
    setIsLoading(true);
    setError({ message: false });
    if (!otp.otpActive) {
      const tokenResp = await authService.initClient({
        staticToken: "TRGV34JKLOIVghjknuyh34421jKIVcyuvhj",
      });
      if (tokenResp.code === 0) {
        setClientToken(tokenResp.clientToken);
        const resp = await authService.login({
          clientToken: tokenResp.clientToken,
          emailAddress: username,
          password: password,
        });
        if (resp.success) {
          setOtp({
            otpActive: true,
            ott: resp.ott,
            message: resp.message,
          });
          setIsLoading(false);
        } else {
          setError({ error: true, message: resp.message });
          setIsLoading(false);
        }
      }
      return;
    } else {
      const resp = await authService.loginOtp({
        clientToken: clientToken,
        otp: otp.otp,
        ott: otp.ott,
      });
      if (resp.success) {
        setToken(resp.token);
        setUser("", {
          email: resp.detail[0].EMAILADDRESS,
          mobile: resp.detail[0].MOBILENUMBER,
          id: resp.detail[0].SUPERADMINID,
          token: resp.token,
          loggedIn: true,
        });
        localStorage.setItem("email", resp.detail[0].EMAILADDRESS);
        localStorage.setItem("mobile", resp.detail[0].MOBILENUMBER);
        localStorage.setItem("token", resp.token);
        localStorage.setItem("id", resp.detail[0].SUPERADMINID);
        localStorage.setItem("uid", resp.detail[0].SUPERADMINUID);
        history.push("/");
      }
      setError({ error: true, message: resp.message });
      setIsLoading(false);
    }
  }

  const onSubmit = () => {
    forgotPassword ? passwordReset() : login();
  };

  return (
    <>
      <img className="loginBg" src={loginBg} />
      <div className="mt-5">
        <Card className="w-50 m-auto">
          <form>
            <CardTitle className="border-bottom p-3 mb-0 font-weight-bold text-uppercase">
              <i class="fas fa-sign-in-alt mr-2"></i>
              Super Admin Login
            </CardTitle>
            <CardBody>
              <Loader isLoading={isLoading} />
              {error.error ? (
                <p class="m-0 small pl-3">{error.message}</p>
              ) : null}
              {!otp.otpActive ? (
                !forgotPassword ? (
                  <React.Fragment key={"login"}>
                    <div className="col-12">
                      <label for="username">{"Email Address"}</label>
                      <input
                        className="form-control"
                        type="text"
                        id="username"
                        placeholder=""
                        onChange={(e) => setUsername(e.target.value)}
                      />
                    </div>
                    <div className="col-12 mt-3">
                      <label for="password">Password</label>
                      <input
                        className="form-control"
                        type={showPassword ? "text" : "password"}
                        id="password"
                        placeholder=""
                        onChange={(e) => setPassword(e.target.value)}
                      />
                    </div>
                    <p
                      class=" mb-0 small pl-3 text-primary font-weight-medium"
                      style={{
                        marginTop: "1.25rem",
                        cursor: "pointer",
                      }}
                      onClick={() => setShowPassword(!showPassword)}
                    >
                      Show password
                    </p>
                    <p
                      onClick={() => setForgotPassword(true)}
                      class=" mb-0 small pl-3 text-primary font-weight-medium"
                      style={{
                        marginTop: "1.25rem",
                        cursor: "pointer",
                      }}
                    >
                      Forgot Password?
                    </p>
                  </React.Fragment>
                ) : (
                  <div className="col-12">
                    <label for="mobileNumber"> Mobile Number</label>
                    <PhoneInput
                      className="form-control"
                      id="mobileNumber"
                      name="mobileNumber"
                      defaultCountry="US"
                      style={{ display: "flex" }}
                      placeholder="Mobile Number"
                      onChange={(e) => setMobileNumber(e)}
                    />
                  </div>
                )
              ) : (
                <React.Fragment key={"otp"}>
                  <p class="mb-3 small pl-3">{otp.message}</p>
                  <div className="col-12">
                    <label for="otp">Enter your OTP</label>
                    <input
                      className="form-control"
                      type="text"
                      id="otp"
                      placeholder=""
                      onChange={(e) =>
                        setOtp({
                          ...otp,
                          otp: e.target.value,
                        })
                      }
                    />
                  </div>
                </React.Fragment>
              )}
            </CardBody>
            <CardFooter>
              <Button color="primary" onClick={onSubmit}>
                {forgotPassword ? "Submit" : "Login"}
              </Button>
              {forgotPassword ? (
                <Button
                  color="secondary ml-2"
                  onClick={() => setForgotPassword(false)}
                >
                  Cancel
                </Button>
              ) : null}
            </CardFooter>
          </form>
        </Card>
      </div>
    </>
  );
}
